export enum LearningClassEnums {
  // --- Element types ---
  Accordion = "Accordion",
  Avatar = "Avatar",
  Button = "Button",
  Card = "Card",
  Checkbox = "Checkbox",
  FormField = "FormField",
  Icon = "Icon",
  Image = "Image",
  Input = "Input",
  Link = "Link",
  ListItem = "ListItem",
  Modal = "Modal",
  Tab = "Tab",
  Text = "Text",

  // --- Layout & global ---
  Header = "Header",
  HelpButton = "HelpButton",
  ImpersonationBanner = "ImpersonationBanner",
  ErrorPageLayout = "ErrorPageLayout",

  // --- Dashboard ---
  LearningDashboardContainer = "LearningDashboardContainer",
  DashboardCTACard = "DashboardCTACard",
  GradeProgress = "GradeProgress",
  PersonalizedGuidancePanel = "PersonalizedGuidancePanel",
  FunFactPanel = "FunFactPanel",

  // --- Grade / Account ---
  SelectGradeModal = "SelectGradeModal",
  StudentAccountDetailsContainer = "StudentAccountDetailsContainer",
  ChangePasswordModal = "ChangePasswordModal",
  PinInputModal = "PinInputModal",
  AvatarSelectModal = "AvatarSelectModal",
  UpdatePasswordModal = "UpdatePasswordModal",

  // --- Terms / Weeks ---
  TermsContainer = "TermsContainer",
  TermContainer = "TermContainer",
  WeekLessonsContainer = "WeekLessonsContainer",
  WeekLessonsSidebar = "WeekLessonsSidebar",

  // --- Subjects ---
  AllSubjectsContainer = "AllSubjectsContainer",
  SubjectContainer = "SubjectContainer",

  // --- Materials / Achievements ---
  GradeMaterialsContainer = "GradeMaterialsContainer",
  AchievementsContainer = "AchievementsContainer",

  // --- Lessons ---
  AudioPlayer = "AudioPlayer",
  LessonDetailContainer = "LessonDetailContainer",
  LessonErrorContainer = "LessonErrorContainer",
  LessonSectionNav = "LessonSectionNav",
  LessonHeaderBreadcrumb = "LessonHeaderBreadcrumb",
  IntroductionContainer = "IntroductionContainer",
  LearnContainer = "LearnContainer",
  PracticeContainer = "PracticeContainer",
  ApplyContainer = "ApplyContainer",
  ReflectContainer = "ReflectContainer",
  SummaryContainer = "SummaryContainer",
  DigitalActivityContainer = "DigitalActivityContainer",
  ActivitySheetDownloadContainer = "ActivitySheetDownloadContainer",
  MoreActivitiesContainer = "MoreActivitiesContainer",
  ReviewContentContainer = "ReviewContentContainer",
  CompletedActivityUploadModal = "CompletedActivityUploadModal",
  ActivityResultsContainer = "ActivityResultsContainer",

  // --- Apply sub-modals ---
  ConfirmSubmissionModal = "ConfirmSubmissionModal",
  IncompleteActivitiesModal = "IncompleteActivitiesModal",
  ContinueWithoutActivityModal = "ContinueWithoutActivityModal",
  NavigateWithoutActivityModal = "NavigateWithoutActivityModal",
  DownloadAnswerSheetModal = "DownloadAnswerSheetModal",
  ReviseLessonConfirmModal = "ReviseLessonConfirmModal",
  ConfirmCompletionModal = "ConfirmCompletionModal",

  // --- No Access / Errors ---
  NoAccessContainer = "NoAccessContainer",
  NotFoundContainer = "NotFoundContainer",
  ServerErrorContainer = "ServerErrorContainer",

  // --- Assignments ---
  AssignmentsDashboardContainer = "AssignmentsDashboardContainer",
  AssignmentDetailContainer = "AssignmentDetailContainer",
  AssignmentRow = "AssignmentRow",
  AssessmentPanel = "AssessmentPanel",
  SubmitAssignmentModal = "SubmitAssignmentModal",
  ExemptAssignmentModal = "ExemptAssignmentModal",
  TermSelectionModal = "TermSelectionModal",
  MarkingRubricModal = "MarkingRubricModal",
  SupportGuideModal = "SupportGuideModal",
  WorkSampleNotifier = "WorkSampleNotifier",
  WorkSampleLearnMoreModal = "WorkSampleLearnMoreModal",

  // --- Orientation ---
  FirstOrientationContainer = "FirstOrientationContainer",
  OrientationWelcomePage = "OrientationWelcomePage",
  ActivitiesOrientationContainer = "ActivitiesOrientationContainer",
  SeniorAssignmentsOrientationContainer = "SeniorAssignmentsOrientationContainer",
  MaterialOrientationContainer = "MaterialOrientationContainer",
  AvatarOrientationContainer = "AvatarOrientationContainer",
  CertificatesOrientationContainer = "CertificatesOrientationContainer",
  SubjectsOrientationContainer = "SubjectsOrientationContainer"
}
